import { outlinedInputClasses, inputAdornmentClasses } from '@ori-ui/mui-bundle/material';
import { textInputData } from '../constants';
const styleOverrides = {
  root: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
    'input::placeholder, textarea::placeholder': {
      color: textInputData.placeholder.color,
      opacity: 1
    },
    borderRadius: 5,
    [`&.${outlinedInputClasses.disabled}`]: {
      color: textInputData.input.disabled
    },
    [`&.${outlinedInputClasses.multiline} .${inputAdornmentClasses.root}`]: {
      alignSelf: 'flex-start',
      marginTop: 16,
      marginRight: 4,
      marginLeft: 4
    }
  },
  inputSizeSmall: {
    padding: '8.5px 14px'
  },
  adornedStart: {
    [`& .${outlinedInputClasses.input}`]: {
      paddingLeft: 0
    }
  },
  adornedEnd: {
    [`& .${outlinedInputClasses.input}`]: {
      paddingRight: 0
    }
  },
  notchedOutline: {
    background: 'unset',
    borderColor: textInputData.border.color,
    '& legend': {
      position: 'unset'
    }
  },
  multiline: {
    padding: 15
  }
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiOutlinedInput.js.map